<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="accessLoader" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="moduleAccess=='Full'">
	<h2 class="card-title mb-0 pb-0">
		Invoice
		<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-invoice']">
			<fa-icon [icon]="['fas', 'plus']"></fa-icon>
			Create Invoice
		</a>
	</h2>
	<div class="card-body pt-1">
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 25% !important;">Company</th>
								<th style="width: 15% !important;">Invoice No.</th>
								<th style="width: 10% !important;">Invoice Date</th>
								<th style="width: 10% !important;text-align: right;">Appt. Count</th>
								<th style="width: 20% !important;text-align: right;">Amount</th>
								<th style="width: 10% !important;">Due Date</th>
								<th style="width: 10% !important;">Action</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.company_name }}</td>
								<td>{{ v.invoice_no }}</td>
								<td>{{ v.invoice_date }}</td>
								<td style="text-align: right;">{{ v.appt_count }}</td>
								<td style="text-align: right;">
									<span>
										<strong *ngIf="getCurrencyName(v.currency)=='SGD'">S</strong>
										<fa-icon
											*ngIf="getCurrencyName(v.currency)=='SGD' || getCurrencyName(v.currency)=='USD'"
											[icon]="['fas', 'dollar-sign']" class="me-1"></fa-icon>
										<fa-icon *ngIf="getCurrencyName(v.currency)=='INR'"
											[icon]="['fas', 'rupee-sign']" class="me-1"></fa-icon>
									</span>
									<span class="me-1">{{ v.amount }}</span>
									<ng-toggle [(ngModel)]="v.paid_unpaid"
										[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
										[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
										[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
										[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="90"
										(change)="changeIsPaid(v,i)"></ng-toggle>
									<fa-icon *ngIf="showIsPaidLoader == i" [icon]="['fas', 'spinner']"
										[animation]="'spin'" class="ms-1"></fa-icon>
								</td>
								<td>{{ v.due_date }}</td>
								<td>
									<a class="btn btn-sm btn-outline-primary" matTooltip="Edit" id="btnEdit{{v.id}}"
										[routerLink]="['/app/edit-invoice',v.id]">
										<fa-icon [icon]="['fas', 'edit']"></fa-icon>
									</a>
									<!-- <button class="btn btn-sm btn-outline-danger ms-1" matTooltip="Delete"
										id="btnDelete{{v.id}}" (click)="deleteModal(v.id,i)">
										<fa-icon *ngIf="showDeleteLoader != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoader == i" [icon]="['fas', 'spinner']"
											[animation]="'spin'"></fa-icon>
									</button> -->
									<button class="btn btn-sm btn-outline-success ms-1" matTooltip="Download Invoice"
										id="btnInvoice{{v.id}}" (click)="getBillPdf(v)">
										<fa-icon *ngIf="pdfDownloadLoader != v.id"
											[icon]="['fas', 'cloud-download-alt']"></fa-icon>
										<fa-icon *ngIf="pdfDownloadLoader == v.id" [icon]="['fas', 'spinner']"
											[animation]="'spin'"></fa-icon>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="7" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="moduleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>